// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.longTermInactive_longTermInactiveModal__v21R4 .comment_content_wrap {
  max-width: 700px;
}

.longTermInactive_longTermInactiveModalContent__gs56P > div:last-child {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.longTermInactive_longTermInactiveModalContent__gs56P > div:last-child > button {
  flex: 1 1;
  padding: 16px 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Dialogs/LongTermInactive/longTermInactive.module.scss"],"names":[],"mappings":"AACC;EACC,gBAAA;AAAF;;AAME;EACC,aAAA;EACA,eAAA;EACA,SAAA;AAHH;AAKG;EACC,SAAA;EACA,iBAAA;AAHJ","sourcesContent":[".longTermInactiveModal {\n :global(.comment_content_wrap) {\n  max-width: 700px;\n }\n}\n\n.longTermInactiveModalContent {\n & > div {\n  &:last-child {\n   display: flex;\n   flex-wrap: wrap;\n   gap: 16px;\n\n   & > button {\n    flex: 1;\n    padding: 16px 4px;\n   }\n  }\n }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"longTermInactiveModal": `longTermInactive_longTermInactiveModal__v21R4`,
	"longTermInactiveModalContent": `longTermInactive_longTermInactiveModalContent__gs56P`
};
export default ___CSS_LOADER_EXPORT___;
